import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CreateToken } from "./CreateToken";
import CreateTokenQueryNode from "./__generated__/CreateTokenQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CreateToken> = {
  root: JSResource("CreateToken", () =>
    import("./CreateToken").then((module) => module.CreateToken),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: CreateTokenQueryNode,
          variables: {},
        },
      },
    };
  },
};

export default entryPoint;
